<script lang="ts" setup>
import { TagProps } from "./Tag.props"

defineProps<TagProps>()
</script>

<template>
  <span class="tag mouse rounded bg-tiffany-30 px-2 py-1">
    {{ name }}
  </span>
</template>
